<div class="pos-relative"
     [sizeClass]="'S: height-100'">
    @if (isModal) {
    <button class="pos-absolute right-0 z-1 flex flex-middle flex-justify-center _close"
            [ngClass]="content.big_popup_image && (!app.client.isS || (app.client.isS && !isChecked())) ? content.bigPopupCloseColor || 'col-b' : 'col-b'"
            type="button"
            [attr.aria-label]="'Close' | translate"
            (click)="close()">
        <i class="icon-close"
           aria-hidden="true"></i>
    </button>
    }
    <div class="flex flex-column-reverse-s"
         [sizeClass]="'S: height-100'">
        <div class="pos-relative bg-col-w"
             [ngClass]="[content.big_popup_image ? 'w-6 w-12-s' : 'w-12', app.client.isS && isChecked() ? 'height-100' : '']">
            <div class="fill-x fill-l fill-m flex-column overflow-hidden overflow-y-auto custom-scrollbar"
                 [sizeClass]="'S: height-100'">
                <div class="vc-outer-x vc-outer-l vc-outer-m flex-column-s flex-justify-end-s"
                     [sizeClass]="'!S: height-100'">
                    <div class="vc-inner">
                        <div class="p-t-2 p-t-6-s p-r-3 p-b-2 p-b-4-s p-l-3 left">
                            <h2 class="p-r-8-s"
                                [ngClass]="content.big_popup_heading_style"
                                sl-login-label="header">
                                @if (!isChecked()) {
                                <span *iCms="'big_popup_main_heading' of content; skipEmpty: true"></span>
                                } @else if (!shouldRegister()) {
                                <span *iCms="'big_popup_login_heading' of content; skipEmpty: true"></span>
                                } @else {
                                <span *iCms="'big_popup_register_heading' of content; skipEmpty: true"></span>
                                }
                            </h2>
                            @if (isChecked()) {
                            @if (!shouldRegister()) {
                            <p class="p1"
                               *iCms="'big_popup_login_subtitle' of content; skipEmpty: true"></p>
                            } @else {
                            <p class="p1 p-b-2-s"
                               *iCms="'big_popup_register_subtitle' of content; skipEmpty: true"></p>
                            }
                            }
                            <form name="create_account_popup"
                                  method="POST"
                                  [attr.sl-form]="shouldRegister() ? 'register' : 'login'"
                                  #form="ngForm">
                                <input-wrap class="pos-relative"
                                            [canShowValidate]="(emailInput?.value?.length > 0 && form.submitAttempt) || form.submitAttempt"
                                            [messages]="{
                                        email: ('Valid email is required' | translate),
                                        required: ('Valid email is required' | translate),
                                        LOQATE_INVALID_EMAIL: ('Valid email is required' | translate)
                                    }">
                                    <input class="input"
                                           type="email"
                                           name="email"
                                           sl-input="email"
                                           cy-loginMailInput
                                           required
                                           validatePatternAsync="email"
                                           [loqateEmail]="true"
                                           [loqateEmailDebounceTime]="500"
                                           [muiInput]="'Email address' | translate"
                                           [(ngModel)]="email"
                                           [ngModelOptions]="{updateOn: 'blur'}"
                                           (keyup)="handleKeyUp($event, form)"
                                           (blur)="handleKeyUp()"
                                           #emailInput>
                                    <!-- @if (isPending) { -->
                                    <span class="pos-absolute flex flex-middle flex-justify-center pe-none _loading">
                                        <i class="icon-loading"
                                           aria-hidden="true"></i>
                                    </span>
                                    <!-- } -->
                                </input-wrap>
                                @if (!isChecked()) {
                                <div class="m-t-2">
                                    <button class="button w-12"
                                            [class.is-disabled]="isPending"
                                            sl-button="continue"
                                            cy-loginMailSubmit
                                            cy-loginSubmit
                                            [action]="checkStatus"
                                            (click)="check()">
                                        <span>{{'Continue' | translate}}</span>
                                    </button>
                                    <result class="m-t-1 block"
                                            sl-result="continue"
                                            cy-loginResult
                                            [status]="checkStatus" />
                                </div>
                                } @else {
                                @if (shouldRegister()) {
                                <div class="w-12"
                                     [grid]="2">
                                    <input-wrap class="w-12">
                                        <input class="input"
                                               type="text"
                                               name="firstname"
                                               required
                                               sl-input="firstname"
                                               cy-registerFnameInput
                                               [muiInput]="'First name' | translate"
                                               [(ngModel)]="$any(data).firstname">
                                    </input-wrap>
                                    <input-wrap class="w-12">
                                        <input class="input"
                                               type="text"
                                               name="lastname"
                                               required
                                               sl-input="lastname"
                                               cy-registerLnameInput
                                               [muiInput]="'Surname' | translate"
                                               [(ngModel)]="$any(data).lastname">
                                    </input-wrap>
                                </div>
                                }
                                <input-wrap class="w-12">
                                    <input class="input"
                                           type="password"
                                           name="password"
                                           cy-loginPwdInput
                                           required
                                           [muiInput]="shouldRegister() ? 'Create a password' : 'Password'"
                                           [(ngModel)]="data.password"
                                           (keyup.enter)="submit()">
                                </input-wrap>
                                @if (!shouldRegister()) {
                                <div class="m-t-1 m-t-2-s m-b-s">
                                    <button class="button-inline"
                                            sl-button="reset"
                                            [action]="passwordStatus"
                                            (click)="resetPassword()">
                                        <span>{{'Forgotten your password?' | translate}}</span>
                                    </button>
                                    <result class="m-t-1 block"
                                            sl-result="reset"
                                            [status]="passwordStatus"
                                            [success]="'We\'ve sent you an email with a link to reset your password.' | translate" />
                                </div>
                                }
                                <!-- newsletter sing up -->
                                @if (showSubscriptionOptIn) {
                                <div class="m-t-2 m-t-3-s login-form-newsletter">
                                    <checkbox class="label block"
                                              name="newsletter"
                                              sl-input="newsletter"
                                              [(ngModel)]="data.newsletter">
                                        <span class="p2">
                                            {{'Subscribe to our email newsletter for newness, sales and more to your
                                            inbox.' | translate}} <a class="underline"
                                               target="_blank"
                                               [routerLink]="'/about-us/privacy-policy'">{{'Privacy policy' |
                                                translate}}</a>
                                        </span>
                                    </checkbox>
                                </div>
                                }
                                <!-- terms and conditions -->
                                @if (shouldRegister()) {
                                <input-wrap class="block p-r-3 p-b-2 p-b-4-s"
                                            [required]="true">
                                    <checkbox name="termsandconditions"
                                              required
                                              [(ngModel)]="$any(data).termsandconditions"
                                              sl-input="termsandconditions"
                                              cy-registerTermsCheckbox>
                                        <span class="inline-block p-t-1 p2">
                                            {{'I agree to the account credit' | translate}}&nbsp;
                                            <a class="underline"
                                               target="_blank"
                                               [routerLink]="'/about-us/terms-and-conditions'">
                                                {{'Terms & Conditions' | translate}}</a>
                                        </span>
                                    </checkbox>
                                </input-wrap>
                                }
                                <div [ngClass]="shouldRegister() ? 'm-t-2' : 'm-t-2 m-t-4-s'">
                                    <button class="button w-12"
                                            sl-button="continue"
                                            cy-loginSubmit
                                            [action]="shouldRegister() ? registerStatus : loginStatus"
                                            (click)="submit()">
                                        <span>
                                            @if (shouldRegister()) {
                                            {{'Create an account' | translate}}
                                            } @else {
                                            {{'Sign in' | translate}}
                                            }
                                        </span>
                                    </button>
                                    <result class="m-t-1 block"
                                            sl-result="continue"
                                            cy-loginResult
                                            [status]="shouldRegister() ? registerStatus : loginStatus" />
                                </div>
                                }
                            </form>
                        </div>
                        <!-- @if (shouldRegister() && !app.client.isS) {
                        <login-form-content-block class="w-12 p-r-2 p-b p-l-2" />
                        } -->
                    </div>
                </div>
            </div>
        </div>
        @if (content.big_popup_image && (!app.client.isS || (app.client.isS && !isChecked()))) {
        <div class="w-6 w-12-s overflow-hidden"
             [ngClass]="content.bigPopupImageRatio || 'ratio-4-5 ratio-3-2-s'">
            <img [dfImage]="content.big_popup_image"
                 [priority]="content.cwvLoading === 'eager' || content.cwvPriority"
                 [ratio]="content.bigPopupImageRatio || app.client.isS ? '3/2' : '4/5'"
                 fill>
        </div>
        }
    </div>
</div>